import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Action, Store } from '@ngrx/store';
import { IState } from '../shared/models/state';
import { Actions } from '@ngrx/effects';
import { GET_PROJECTS_SUCCESS, GetProjectsAction } from './reports.actions';
import { Observable } from 'rxjs';

@Injectable()
export class ProjectsResolve implements Resolve<Action> {
  constructor(private store: Store<IState>, private action$: Actions) {}

  resolve(): Observable<Action> {
    this.store.dispatch(new GetProjectsAction());
    return this.action$.ofType(GET_PROJECTS_SUCCESS).take(1);
  }
}
